import NoIntegration from 'assets/js/pages/contacts/single/donor-search/NoIntegration';
import Searched from 'assets/js/pages/contacts/single/donor-search/Searched';
import Unsearched from 'assets/js/pages/contacts/single/donor-search/Unsearched';
import { useDonorSearchIntegration } from 'assets/js/pages/contacts/single/donor-search/useDonorSearchIntegration';
import { useCurrentContact } from 'customHooks/useCurrentContact';

const DonorSearch = () => {
    const { data: contact } = useCurrentContact();
    const { data: integration } = useDonorSearchIntegration();

    if (!integration) {
        return <NoIntegration />;
    }

    return contact.donorsearch === null ? <Unsearched /> : <Searched />;
};

export default DonorSearch;
